<template>
  <div>
    <h1 class="mb-8 font-bold text-3xl">Especies</h1>

    <div class="mb-6 flex justify-between items-center">
      <search-filter v-model="form.search" class="w-full max-w-md mr-4" @reset="reset" />

      <button class="btn-indigo" type="button" @click="openModal = true">
        <span>Agregar</span>
        <span class="hidden md:inline">Especie</span>
      </button>
    </div>

    <div class="bg-white rounded-md shadow overflow-x-auto">
      <table class="w-full whitespace-nowrap">
        <tr class="text-left font-bold">
          <th class="px-6 pt-6 pb-4">Nombre</th>
          <th class="px-6 pt-6 pb-4">Descripción</th>
        </tr>

        <tr v-for="e in especies.data" :key="e.id" class="hover:bg-gray-100 focus-within:bg-gray-100">
           <td class="border-t">
            <inertia-link class="px-6 py-4 flex items-center" :href="route('especies.edit', e.id)" tabindex="-1">
              {{ e.nombre }}
            </inertia-link>
          </td>
          <td class="border-t">
            <inertia-link class="px-6 py-4 flex items-center" :href="route('especies.edit', e.id)" tabindex="-1">
              {{ e.descripcion }}
            </inertia-link>
          </td>
        </tr>

        <tr v-if="especies.data.length === 0">
          <td class="border-t px-6 py-4" colspan="2">No hay especies registradas</td>
        </tr>
      </table>
    </div>

    <pagination class="mt-6" :links="especies.links" />

    <!-- MODAL (listo para conectar store después) -->
    <div v-if="openModal" class="fixed inset-0 z-50 flex items-start justify-center px-4 pt-10 md:pt-16">
      <div class="absolute inset-0 bg-gradient-to-b from-black/60 via-black/35 to-black/60" @click="closeModal"></div>

      <div class="relative bg-white rounded-md shadow-xl overflow-hidden w-full max-w-3xl mb-10">
        <div class="px-8 py-4 bg-gray-50 border-b border-gray-100 flex justify-between items-center">
          <div class="font-bold">Registrar Especie</div>
          <button type="button" class="text-gray-500 hover:text-gray-800" @click="closeModal">✕</button>
        </div>

        <div class="max-h-[80vh] overflow-y-auto">
          <form @submit.prevent="store">
            <div class="p-8 -mr-6 -mb-8 flex flex-wrap">
              <text-input v-model="especieForm.nombre" :error="especieForm.errors.nombre"
                class="pr-6 pb-8 w-full lg:w-1/2" label="Nombre de la especie" required />

              <text-input v-model="especieForm.tipo_manejo_reproductivo"
                :error="especieForm.errors.tipo_manejo_reproductivo" class="pr-6 pb-8 w-full lg:w-1/2"
                label="Tipo de manejo reproductivo" />

              <text-input v-model="especieForm.descripcion" :error="especieForm.errors.descripcion"
                class="pr-6 pb-8 w-full" label="Descripción" />
            </div>

            <div class="px-8 py-4 bg-gray-50 border-t border-gray-100 flex justify-end items-center">
              <loading-button :loading="especieForm.processing" class="btn-indigo" type="submit">
                Guardar Especie
              </loading-button>
            </div>
          </form>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import pickBy from 'lodash/pickBy'
import throttle from 'lodash/throttle'
import mapValues from 'lodash/mapValues'
import Layout from '@/Shared/Layout'
import Pagination from '@/Shared/Pagination'
import SearchFilter from '@/Shared/SearchFilter'
import TextInput from '@/Shared/TextInput'
import LoadingButton from '@/Shared/LoadingButton'

export default {
  metaInfo: { title: 'Especies' },
  layout: Layout,
  components: { Pagination, SearchFilter, TextInput, LoadingButton },
  props: {
    filters: [Object, Array],
    especies: Object,
  },
  data() {
    return {
      openModal: false,
      form: {
        search: this.filters && this.filters.search ? this.filters.search : null,
      },
      especieForm: this.$inertia.form({
        nombre: null,
        descripcion: null,
        tipo_manejo_reproductivo: null,
      }),
    }
  },
  watch: {
    form: {
      deep: true,
      handler: throttle(function () {
        this.$inertia.get(this.route('especies'), pickBy(this.form), { preserveState: true })
      }, 150),
    },
  },
  methods: {
    reset() {
      this.form = mapValues(this.form, () => null)
    },
    closeModal() {
      this.openModal = false
      this.especieForm.clearErrors()
    },
    // 👇 lo conectamos cuando crees especies.store
    store() {
      this.especieForm.post(this.route('especies.store'), {
        preserveScroll: true,
        onSuccess: () => {
          this.openModal = false
          this.especieForm.reset()
        },
      })
    },
  },
}
</script>